export default __webpack_public_path__ + "static/media/telegram.6d4fb402.png";